module.exports = __webpack_public_path__ + "img/coin.4017981b.svg";